import { makeApiRequest } from './apiBody';

async function loginIntermediary(values) {
  try {
    const data = {
        username : values?.username?.trim(),
        password : values?.password,
        loginDevice : {}
    };

    const response = await makeApiRequest({
      serviceName: 'user',
      resourceName: 'auth',
      actionName: 'login',
      data,
    });
    sessionStorage.setItem("token", response.accessToken);

    return response;
  } catch (err) {
    throw err; // Let the caller handle the error
  }
}



async function registerIntermediary(values) {
  try {
    const regData = {
      primaryEmail: values.email,
      licenseNumber: values.ira_code,
      category: values.category,
      intermediaryUser: {
        names: values.names,
        email: values.email,
      },
    };

    const response = await makeApiRequest({
      resourceName: 'intermediary',
      actionName: 'registration',
      data: regData,
    });

    return response;
  } catch (err) {
    throw err; // Let the caller handle the error
  }
}


async function verifyOTP(values) {
  try {
    const data = {
        registrationId : values.regId,
        registrationCode : values.code
    };

    const response = await makeApiRequest({
      serviceName: 'user',
      resourceName: 'registration',
      actionName: 'registrationValidation',
      data,
    });

    return response;
  } catch (err) {
    throw err; // Let the caller handle the error
  }
}




async function createIntermediary(regId, names, credentials) {
  try {
    const data = {
         registrationId : regId,
         username : credentials?.username?.trim(),
         password : credentials.password,
        // "contacts": "0708801050"
    };

    const response = await makeApiRequest({
      serviceName: 'user',
      resourceName: 'registration',
      actionName: 'createUser',
      data,
    });

    return response;
  } catch (err) {
    throw err; // Let the caller handle the error
  }
}
export { 
    registerIntermediary, 
    loginIntermediary,
    verifyOTP,
    createIntermediary,

};